"use client";

import { create } from "zustand";
import { api } from "../api";
import { getAccessToken, setTokens, clearTokens } from "../auth-tokens";
import type { User, AuthResponse } from "../types";

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, name: string) => Promise<void>;
  logout: () => void;
  loadUser: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,

  login: async (email, password) => {
    const data = await api.post<AuthResponse>("/api/auth/login", {
      email,
      password,
    });
    setTokens(data.accessToken, data.refreshToken);

    const user = await api.get<User>("/api/user/profile");
    set({ user, isAuthenticated: true });
  },

  register: async (email, password, name) => {
    const data = await api.post<AuthResponse>("/api/auth/register", {
      email,
      password,
      name,
    });
    setTokens(data.accessToken, data.refreshToken);

    const user = await api.get<User>("/api/user/profile");
    set({ user, isAuthenticated: true });
  },

  logout: () => {
    clearTokens();
    set({ user: null, isAuthenticated: false });
    window.location.href = "/login";
  },

  loadUser: async () => {
    if (!getAccessToken()) {
      set({ isLoading: false, isAuthenticated: false });
      return;
    }
    try {
      const user = await api.get<User>("/api/user/profile");
      set({ user, isAuthenticated: true, isLoading: false });
    } catch {
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },
}));
